/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapmoms } from './pages'

type TIdToPageMap = Record<PageIdStylioCapmoms, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPMOMS: TIdToPageMap = {
  [PageIdStylioCapmoms.AGE_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapmoms.URGE_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePage'),
  },
  [PageIdStylioCapmoms.HAIR_COLOR_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapmoms.EYES_COLOR_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapmoms.JEWELRY_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapmoms.BODY_SHAPE_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapmoms.STYLIO_TO_HELP_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapmoms.TALL_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapmoms.WEIGHT_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapmoms.URGE_2_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapmoms.FEEL_ABOUT_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapmoms.PERCENTAGE_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/PercentageQuestion'),
  },
  [PageIdStylioCapmoms.SHOPPING_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapmoms.STYLE_MOST_MATTERS_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapmoms.FAVORITE_COLORS_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_11_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_12_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_13_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_14_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages//likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages//likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_15_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_16_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_17_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_18_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_19_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapmoms.STYLES_FEEL_LIKE_YOU_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapmoms.URGE_3_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapmoms.TIME_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/TimeQuestion'),
  },
  [PageIdStylioCapmoms.TYPICAL_DAY_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/TypicalDayQuestion'
      ).then((m) => ({
        default: m.TypicalDayQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/TypicalDayQuestion'),
  },
  [PageIdStylioCapmoms.YOUR_LOCATION_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/abtest/YourLocation/YourLocation'
      ).then((m) => ({
        default: m.YourLocation,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/abtest/YourLocation/YourLocation'),
  },
  [PageIdStylioCapmoms.BRAND_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapmoms.FIND_NEW_CLOTHES_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapmoms.NOTHING_TO_WEAR_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapmoms.OLD_CLOTHES_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioCapmoms.COMBINE_CLOTHES_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapmoms.OPTIMIZE_BUDGET_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapmoms.URGE_4_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapmoms.PREPARE_FLOW_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapmoms.EMAIL_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms/pages/email/Email'),
  },
  [PageIdStylioCapmoms.EMAIL_CONSENT_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/email/EmailConsent'),
  },
  [PageIdStylioCapmoms.PRE_PAYWALL_OFFER_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/abtest/PrePaywallOffer/PrePaywallOffer'
      ).then((m) => ({
        default: m.PrePaywallOffer,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/abtest/PrePaywallOffer/PrePaywallOffer'
      ),
  },
  [PageIdStylioCapmoms.SUBSCRIPTIONS_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioCapmoms.CANCEL_OFFER_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapmoms.SUB_UPSELL_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapmoms.UPSELL_CAPMOMS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capmoms/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capmoms/pages/upsell/Upsell'),
  },
  [PageIdStylioCapmoms.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapmoms.DOWNLOAD_CAPMOMS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capmoms/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capmoms/pages/download-app/DownloadDefault'),
  },
}
